module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.datas), function(data) {
    return _c('div', [(!data.pList || data.pList.length == 0 && data.idx != 1264 && data.idx != 1493 && data.idx != 600) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.updatePicSrc(data.imgUrl),
        "width": "100%"
      },
      on: {
        "click": function($event) {
          _vm.redirect(data.openUrl, data)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (data.pList && data.pList.length > 0 && (data.idx == 1200 || data.idx == 1490)) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "97vw",
        "margin-left": "3vw"
      },
      attrs: {
        "src": _vm.updatePicSrc(data.imgUrl)
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "94vw",
        "padding-left": "3vw"
      }
    }, _vm._l((_vm.getGoods2Show(data)), function(d) {
      return _c('img', {
        staticStyle: {
          "width": "47vw"
        },
        attrs: {
          "src": _vm.updatePicSrc(d.headImage_s)
        },
        on: {
          "click": function($event) {
            _vm.public.gotoDetail(d, _vm.public.headType.h5Main, d.idx)
          }
        }
      })
    })), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "5px",
        "width": "100vw",
        "background": "#f8f8f8"
      }
    })]) : _vm._e(), _vm._v(" "), (data.idx == 600 || data.idx == 1493) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "97vw",
        "margin-left": "3vw"
      },
      attrs: {
        "src": _vm.updatePicSrc(data.imgUrl)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "newHomePage_hotIdx"
    }, _vm._l((_vm.hotGoodsIdx), function(i) {
      return _c('div', {
        staticClass: "hotIdx",
        on: {
          "click": function($event) {
            _vm.gotoRecomend(i)
          }
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(i.title))]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_vm._v(_vm._s(i.desc))]), _vm._v(" "), _c('img', {
        staticClass: "img",
        attrs: {
          "src": _vm.updatePicSrc(i.imgUrl)
        }
      })])
    })), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "5px",
        "width": "100%",
        "background": "#f8f8f8"
      }
    })]) : _vm._e(), _vm._v(" "), (data.pList && data.pList.length > 0 && (data.idx == 601 || data.idx == 1491 || data.idx == 1221 || data.idx == 1492 || data.idx == 1789)) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "97vw",
        "margin-left": "3vw"
      },
      attrs: {
        "src": _vm.updatePicSrc(data.imgUrl)
      },
      on: {
        "click": function($event) {
          _vm.gotoRecomend(data)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "newHomePage_box"
    }, _vm._l((_vm.getGoods2Show(data)), function(d) {
      return _c('div', {
        staticClass: "show",
        on: {
          "click": function($event) {
            _vm.public.gotoDetail(d, _vm.public.headType.h5Main, d.idx)
          }
        }
      }, [_c('img', {
        staticClass: "goodsPic",
        attrs: {
          "src": _vm.updatePicSrc(d.Pic)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(d.sTitle ? d.sTitle : d.D_title))]), _vm._v(" "), _c('div', {
        staticClass: "priceBox"
      }, [_c('div', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(d.Price))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (d.Quan_price > 0),
          expression: "d.Quan_price > 0"
        }],
        staticClass: "quanPrice"
      }, [_vm._v(_vm._s(parseFloat(d.Quan_price)) + "元券")])])])
    })), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "5px",
        "width": "100%",
        "background": "#f8f8f8"
      }
    })]) : _vm._e(), _vm._v(" "), (data.pList && data.pList.length > 0 && (data.idx == 1629 || data.idx == 1593)) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "97vw",
        "margin-left": "3vw"
      },
      attrs: {
        "src": _vm.updatePicSrc(data.imgUrl)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "newHomePage_box"
    }, _vm._l((_vm.getGoods2Show(data)), function(d) {
      return _c('div', {
        staticClass: "show",
        on: {
          "click": function($event) {
            _vm.public.gotoDetail(d, _vm.public.headType.h5Main, d.idx)
          }
        }
      }, [_c('img', {
        staticClass: "goodsPic",
        attrs: {
          "src": _vm.updatePicSrc(d.Pic)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(d.sTitle ? d.sTitle : d.D_title))]), _vm._v(" "), _c('div', {
        staticClass: "priceBox"
      }, [_c('div', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(d.Price))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.getJdReward(d) > 0),
          expression: "getJdReward(d) > 0"
        }],
        staticClass: "JDQuanPrice"
      }, [_vm._v("奖励" + _vm._s(_vm.getJdReward(d)) + "元")])])])
    })), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "5px",
        "width": "100%",
        "background": "#f8f8f8"
      }
    })]) : _vm._e(), _vm._v(" "), (data.pList && data.pList.length > 0 && data.idx == 1205) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "97vw",
        "margin-left": "3vw"
      },
      attrs: {
        "src": _vm.updatePicSrc(data.imgUrl)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "newHomePage_box"
    }, _vm._l((_vm.getGoods2Show(data)), function(d) {
      return _c('div', {
        staticClass: "show",
        on: {
          "click": function($event) {
            _vm.public.gotoDetail(d, _vm.public.headType.h5Main, d.idx)
          }
        }
      }, [_c('img', {
        staticClass: "goodsPic",
        attrs: {
          "src": _vm.updatePicSrc(d.Pic)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(d.sTitle ? d.sTitle : d.D_title))]), _vm._v(" "), _c('div', {
        staticClass: "priceBox"
      }, [_c('div', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(d.Price))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (d.Quan_price > 0),
          expression: "d.Quan_price > 0"
        }],
        staticClass: "quanPrice"
      }, [_vm._v(_vm._s(parseFloat(d.Quan_price)) + "元券")])])])
    })), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "5px",
        "width": "100%",
        "background": "#f8f8f8"
      }
    })]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30757857","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/NewHomePage.vue
// module id = 201
// module chunks = 2